export const isAddressValid = (address) => {
    if (!address) return true; // Allow empty address

    const upperAddress = address.toUpperCase();

    // Allow all US states - just check if it contains USA, US, or UNITED STATES
    const containsUSA = upperAddress.includes("USA") || upperAddress.includes("US") || upperAddress.includes("UNITED STATES");

    return containsUSA;
};
